export const UPDATE_USAGE_STATE = 'UPDATE_USAGE_STATE'